import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '途中で解約できますか？',
      answer: 'はい。最低契約期間はありません。月単位でいつでも解約可能です。'
    },
    {
      question: 'デザインの自由度はどのくらいですか？',
      answer: 'テンプレートベースですが、お店の雰囲気に合わせた色・写真・レイアウトのカスタマイズが可能です。'
    },
    {
      question: '自分で更新することはできますか？',
      answer: '基本的な更新は弊社で対応します。12ヶ月後にコードをお渡しするので、その後はご自由に編集可能です。'
    },
    {
      question: 'ドメインはどうなりますか？',
      answer: '新規取得も持ち込みも対応可能。取得代行の場合は¥5,000/年（ドメイン実費別）で管理します。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            よくある質問
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-slate-50 rounded-xl border-2 border-slate-200 overflow-hidden hover:border-cyan-600 transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-slate-100 transition-colors duration-200"
              >
                <span className="text-lg font-bold text-slate-800 pr-4">
                  {faq.question}
                </span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-cyan-600 flex-shrink-0`}></i>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-slate-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}